import { flagValue, type FlagKey } from '@atbash-labs/ontology-flags'

import { useFlagSnapshot } from './FlagSnapshotProvider'

/** Snapshot value, else generated default — never undefined, never suspends. */
export function useFlag(key: FlagKey): boolean {
  const { snapshot } = useFlagSnapshot()
  return flagValue(snapshot.flags, key)
}

export function useFlagsStale(): boolean {
  return useFlagSnapshot().stale
}
